var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Search } from '@mui/icons-material';
import { Box, Chip, debounce, Link, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterIcon } from '../../../assets/customIcons';
import { ReactComponent as CrossCircleIocn } from '../../../assets/images/crossCircleIocn.svg';
import { getUpdateKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { DesktopTabComponent } from '../../../components/molecules/desktopTabComponent';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { showNotification } from '../../../redux/commonSlice';
import { createAPI, getListAPI, setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { InvoicedTab } from '../pages/invoicedTab';
import ReadyForInvoiceTab from '../pages/readyForInvoiceTab';
import { configurationGet, JCIFilterPagingAPI, JobCardInvoicesKeys } from '../services/entity';
import JCIFilter from './JCIFilter';
import { jciInvoiceCountAPI, jciReadyForInvoiceCountAPI } from '../services/apiCall';
var JobCardInvoiceTabs = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _getLocalStorageItem4, _crud, _crud2, _crud3, _crud4;
    var crud = useAppSelector(function (state) { return state.crud; });
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var navigate = useNavigate();
    var IS_MOBILE = upXS && downSM;
    var IdentityId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var organizationId = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.OrganizationId;
    var branch = (_getLocalStorageItem4 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem4 === void 0 || (_getLocalStorageItem4 = _getLocalStorageItem4.data) === null || _getLocalStorageItem4 === void 0 ? void 0 : _getLocalStorageItem4.Branches.map(function (it) { return it === null || it === void 0 ? void 0 : it.OrganizationId; });
    var _a = useState(), isMyView = _a[0], setIsMyView = _a[1];
    var listVariants = [{
            Name: 'All Job Card Invoice',
            id: 'all'
        }, {
            Name: "My Job Card Invoice",
            id: IdentityId
        }];
    var dispatch = useAppDispatch();
    var selectedBranch = getLocalStorageItem("SELECTED_BRANCH");
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, readyforInvoiceData, invoiceData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(createAPI({
                            key: JobCardInvoicesKeys.ConfigurationGet,
                            url: configurationGet,
                            request: {
                                Key: "invoiceConfiguration"
                            }
                        }))];
                    case 1:
                        res = _a.sent();
                        readyforInvoiceData = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var ReadyForinvoicedReq, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        ReadyForinvoicedReq = _objectSpread(_objectSpread({}, isMyView !== 'all' && isMyView !== undefined && {
                                            IdentityId: IdentityId
                                        }), {}, {
                                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                            Branches: branch,
                                            Status: ["ReadyForInvoice"],
                                            PagingFor: "Job Card",
                                            take: 10,
                                            skip: 0
                                        });
                                        return [4 /*yield*/, jciReadyForInvoiceCountAPI({
                                                request: ReadyForinvoicedReq
                                            })];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        readyforInvoiceData();
                        invoiceData = function () { return __awaiter(void 0, void 0, void 0, function () {
                            var invoicedReq, response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        invoicedReq = _objectSpread(_objectSpread({}, isMyView !== 'all' && isMyView !== undefined && {
                                            IdentityId: IdentityId
                                        }), {}, {
                                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                            InvoiceTypeName: "JobCardInvoice",
                                            PagingFor: "Invoice"
                                        });
                                        return [4 /*yield*/, jciInvoiceCountAPI({
                                                request: invoicedReq
                                            })];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        invoiceData();
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [isMyView]);
    var JCIReadyForInvoiceTab = [{
            type: FormItemTypes.Custom,
            name: 'Ready-for-invoiced',
            element: ReadyForInvoiceTab,
            columnSize: 12
        }];
    var JCIDraftTab = [{
            type: FormItemTypes.Custom,
            name: 'Draft',
            element: undefined,
            columnSize: 12
        }];
    var JCInvoicedTab = [{
            type: FormItemTypes.Custom,
            name: 'Invoice',
            element: InvoicedTab,
            columnSize: 12
        }];
    var formData = [{
            type: FormItemTypes.SingleSelect,
            name: 'IdentityId',
            value: !isAllViewActive ? listVariants[0].id : listVariants[1].id,
            options: listVariants,
            valueExpr: 'id',
            displayExpr: 'Name',
            size: 'medium',
            columnSize: 0,
            disableUnderline: true,
            variant: 'standard',
            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setIsMyView(currValue);
                    return [2 /*return*/, {}];
                });
            }); },
            sx: {
                fontWeight: 'strong',
                fontSize: '50px !important',
                padding: '20px 24px 20px 24px'
            }
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '76px',
            padding: '20px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            })
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'search',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by VIN, Reg No, Doc No.',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = (currValue === null || currValue === void 0 ? void 0 : currValue.trim()) || '',
                                    _a);
                            },
                            setFormState: debounce(function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                                var trimmedValue, commonRequest, readyForInvoiceTab, invoicedTab, _res$payload, key, res, _res$payload2, err_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            trimmedValue = (currValue === null || currValue === void 0 ? void 0 : currValue.trim()) || '';
                                            commonRequest = {
                                                SearchFor: formValues === null || formValues === void 0 ? void 0 : formValues.Tabs,
                                                OrganizationId: organizationId,
                                                ParentOrganizationId: parentOrganizationId,
                                                skip: 0,
                                                take: 10
                                            };
                                            readyForInvoiceTab = {
                                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                                ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                                Branches: branch,
                                                Status: ["ReadyForInvoice"],
                                                PagingFor: "Job Card",
                                                skip: 0,
                                                take: 10
                                            };
                                            invoicedTab = {
                                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                                ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                                InvoiceTypeName: "JobCardInvoice",
                                                PagingFor: "Invoice",
                                                skip: 0,
                                                take: 10
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 6, , 7]);
                                            if (!!trimmedValue) return [3 /*break*/, 3];
                                            return [4 /*yield*/, dispatch(getListAPI({
                                                    key: (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) === "Invoice" ? "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice") : "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "ReadyForInvoice"),
                                                    url: JCIFilterPagingAPI,
                                                    request: _objectSpread({}, (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) === "Invoice" ? invoicedTab : readyForInvoiceTab)
                                                }))];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 5];
                                        case 3:
                                            if (!(trimmedValue.length >= 3)) return [3 /*break*/, 5];
                                            key = (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) === 'Invoice' ? "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice") : "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "ReadyForInvoice");
                                            return [4 /*yield*/, dispatch(getListAPI({
                                                    key: key,
                                                    url: JCIFilterPagingAPI,
                                                    request: _objectSpread(_objectSpread({}, commonRequest), {}, {
                                                        search: trimmedValue
                                                    })
                                                }))];
                                        case 4:
                                            res = _a.sent();
                                            if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.errorCode) {
                                                dispatch(showNotification({
                                                    isOpen: true,
                                                    message: trimmedValue.length >= 17 ? 'Job card is not marked as Ready for Invoice' : res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.message,
                                                    type: "error",
                                                    isLinkToaster: true,
                                                    linkComponent: trimmedValue.length >= 17 ? /*#__PURE__*/ React.createElement(Link, {
                                                        component: "button",
                                                        variant: "h3",
                                                        onClick: function () { return navigate("/jobCard"); },
                                                        sx: {
                                                            color: 'white',
                                                            textDecorationColor: 'white',
                                                            textDecoration: 'underline'
                                                        }
                                                    }, trimmedValue ? "Click Here" : "") : null
                                                }));
                                            }
                                            _a.label = 5;
                                        case 5: return [3 /*break*/, 7];
                                        case 6:
                                            err_1 = _a.sent();
                                            console.error('Search API error:', err_1);
                                            return [3 /*break*/, 7];
                                        case 7: return [2 /*return*/, {}];
                                    }
                                });
                            }); }, 400)
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'closeButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(CrossCircleIocn, {
                                color: "currentColor",
                                height: '18px',
                                width: '18px'
                            }),
                            setFieldProps: function (state) {
                                var _state$search;
                                var shouldShow = (state === null || state === void 0 || (_state$search = state.search) === null || _state$search === void 0 || (_state$search = _state$search.trim()) === null || _state$search === void 0 ? void 0 : _state$search.length) >= 3;
                                return {
                                    type: FormItemTypes.IconButton,
                                    sx: {
                                        color: 'secondary',
                                        display: shouldShow ? 'inline-flex' : 'none'
                                    }
                                };
                            },
                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                var readyForInvoiceTab, invoicedTab;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            readyForInvoiceTab = {
                                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                                ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                                Branches: branch,
                                                Status: ["ReadyForInvoice"],
                                                PagingFor: "Job Card",
                                                skip: 0,
                                                take: 10
                                            };
                                            invoicedTab = {
                                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                                ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                                                InvoiceTypeName: "JobCardInvoice",
                                                PagingFor: "Invoice",
                                                skip: 0,
                                                take: 10
                                            };
                                            return [4 /*yield*/, dispatch(getListAPI({
                                                    key: (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) === "Invoice" ? "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice") : "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "ReadyForInvoice"),
                                                    url: JCIFilterPagingAPI,
                                                    request: _objectSpread({}, (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) === "Invoice" ? invoicedTab : readyForInvoiceTab)
                                                }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/, {
                                                    search: null
                                                }];
                                    }
                                });
                            }); }
                        }]
                }, {
                    type: FormItemTypes.Button,
                    name: 'filterButton',
                    children: !IS_MOBILE ? "Filters" : null,
                    columnSize: 0,
                    color: 'secondary',
                    variant: 'outlined',
                    sx: {
                        padding: '10px'
                    },
                    startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                    setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        var _response$payload, response, filterData, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 4, , 5]);
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: JCIFilter,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: IS_MOBILE ? "auto" : "400px"
                                                    }
                                                },
                                                anchor: IS_MOBILE ? "bottom" : "right"
                                            },
                                            componentProps: {
                                                data: formValues
                                            }
                                        }))];
                                case 1:
                                    response = _a.sent();
                                    filterData = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.formData;
                                    if (!filterData) return [3 /*break*/, 3];
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            url: JCIFilterPagingAPI,
                                            key: "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice"),
                                            request: {
                                                OrganizationId: filterData.OrganizationId,
                                                ParentOrganizationId: parentOrganizationId,
                                                ServiceAdvisorId: filterData.ServiceAdvisorId,
                                                ProductId: filterData.ProductId,
                                                PostingTypeId: filterData.PostingTypeId,
                                                InvoiceStartDate: filterData.InvoiceStartDate,
                                                InvoiceEndDate: filterData.InvoiceEndDate,
                                                InvoiceTypeName: "JobCardInvoice",
                                                PagingFor: "Invoice",
                                                take: 10,
                                                skip: 0
                                            }
                                        }))];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/, {
                                        applyFilter: true
                                    }];
                                case 4:
                                    error_1 = _a.sent();
                                    console.error("Error in setFormState:", error_1);
                                    return [2 /*return*/, {
                                            applyFilter: false
                                        }];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); },
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        var isDisabled = (formValues === null || formValues === void 0 ? void 0 : formValues.Tabs) !== 'Invoice';
                        return {
                            disabled: isDisabled
                        };
                    }
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            valueExpr: 'id',
            displayExpr: 'Name',
            columnSize: 12,
            sx: {
                paddingX: '24px',
                rowGap: '16px'
            },
            panelGridProps: {
                spacing: 0,
                sx: {
                    xs: '24px',
                    sm: '24px'
                }
            },
            setFormState: function (formValues, currValue, field) {
                return _objectSpread(_objectSpread({}, formValues), {}, {
                    search: ''
                });
            },
            tabs: [{
                    id: 'ready-for-invoiced',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Ready for invoiced"), /*#__PURE__*/ React.createElement(Chip
                    // label={crud[JobCardInvoicesKeys.JCIFilterPagingKey]?.count ? crud[JobCardInvoicesKeys.JCIFilterPagingKey]?.count : '0'}
                    // label={crud[`${JobCardInvoicesKeys.JCIFilterPagingKey}ReadyForInvoice`]?.count ? crud[`${JobCardInvoicesKeys.JCIFilterPagingKey}ReadyForInvoice`]?.count : 0}
                    , {
                        label: (_crud = crud["".concat(JobCardInvoicesKeys.ReadyForInvoiceCount)]) !== null && _crud !== void 0 && _crud.count ? (_crud2 = crud["".concat(JobCardInvoicesKeys.ReadyForInvoiceCount)]) === null || _crud2 === void 0 ? void 0 : _crud2.count : 0,
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: JCIReadyForInvoiceTab
                },
                // {
                //     id: 'draft',
                //     Name: 'Draft',
                //     elements: JCIDraftTab
                // },
                {
                    id: 'Invoice',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Invoiced"), /*#__PURE__*/ React.createElement(Chip
                    // label={crud[`${JobCardInvoicesKeys.JCIFilterPagingKey}Invoice`]?.count ? crud[`${JobCardInvoicesKeys.JCIFilterPagingKey}Invoice`]?.count : 0}
                    , {
                        label: (_crud3 = crud["".concat(JobCardInvoicesKeys.InvoiceCount)]) !== null && _crud3 !== void 0 && _crud3.count ? (_crud4 = crud["".concat(JobCardInvoicesKeys.InvoiceCount)]) === null || _crud4 === void 0 ? void 0 : _crud4.count : 0,
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    elements: JCInvoicedTab
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        gridProps: {
            spacing: 0
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            if (e && (field === null || field === void 0 ? void 0 : field.name) === 'Tabs' || (field === null || field === void 0 ? void 0 : field.name) === 'IdentityId') {
                dispatch(setReducerState({
                    key: getUpdateKey((state === null || state === void 0 ? void 0 : state.Tabs) === "Invoice" ? JobCardInvoicesKeys.JCIFilterPagingKey + 'Invoice' : JobCardInvoicesKeys.JCIFilterPagingKey + 'ReadyForInvoice'),
                    value: true
                }));
            }
        }
    }));
};
export default JobCardInvoiceTabs;
